import { UserManager } from '@/Admin/UserManager'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/userManager/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <UserManager/>
}
